import {Component, EventEmitter, Input, Output} from '@angular/core';
import {CommonModule} from '@angular/common';

export type DailyPatientCarerToggleValue = 'patient' | 'carer';

/**
 * Patient/Carer segmented toggle shown at the top right of the Daily Summary panel header,
 * aligned with the "Daily Summary" title (UNIVAPLAT-2360).
 *
 * Purely presentational: the host page decides whether to render it at all (only when the
 * patient has BOTH a patient-side record and a carer record — otherwise there is nothing to
 * switch to/from) and owns navigation to the other daily-detail route on `(select)`, the same
 * way it already owns prev/next-day navigation.
 */
@Component({
    selector: 'cdss-daily-patient-carer-toggle',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './daily-patient-carer-toggle.component.html',
    styleUrl: './daily-patient-carer-toggle.component.scss',
})
export class DailyPatientCarerToggleComponent {
    /** Which side is currently active — the host page's own variant. */
    @Input() active: DailyPatientCarerToggleValue = 'patient';

    /** Emitted with the newly chosen side when it differs from `active`. */
    @Output() select = new EventEmitter<DailyPatientCarerToggleValue>();

    choose(value: DailyPatientCarerToggleValue): void {
        if (value !== this.active) {
            this.select.emit(value);
        }
    }
}
